var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatching1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1056 0.447213C14.6686 0.165686 15.3314 0.165686 15.8944 0.447214L28.8944 6.94721C29.572 7.286 30 7.97852 30 8.73607V16.6667V24.5973C30 25.3548 29.572 26.0473 28.8944 26.3861L15.8944 32.8861C15.3314 33.1676 14.6686 33.1676 14.1056 32.8861L1.10557 26.3861C0.428004 26.0473 0 25.3548 0 24.5973V16.6667L0 8.73607C0 7.97852 0.428005 7.286 1.10557 6.94721L14.1056 0.447213Z",
    fill: "#74B089"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2170_7858",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9.16666,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2170_7858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 22.2917L8.75 14.7917L10.625 11.0417H19.375L21.25 14.7917L15 22.2917ZM13.5156 14.1667H16.4844L15.5469 12.2917H14.4531L13.5156 14.1667ZM14.375 19.5885V15.4167H10.9062L14.375 19.5885ZM15.625 19.5885L19.0938 15.4167H15.625V19.5885ZM17.875 14.1667H19.5312L18.5938 12.2917H16.9375L17.875 14.1667ZM10.4688 14.1667H12.125L13.0625 12.2917H11.4062L10.4688 14.1667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatching1);
export default __webpack_public_path__ + "static/media/matching1.f05c7d47.svg";
export { ForwardRef as ReactComponent };